export enum StatisticalAnalysisSimpleListEntitiesAllowedEnum {
    CASE_VIRTUAL_STATE = 'CASE_VIRTUAL_STATE',
}
